var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5996,
    cy: 45,
    r: 44,
    fill: "white",
    stroke: "#B9D7FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6941 23.792H57.6779V22.7758C57.6779 21.091 56.3142 19.7273 54.6294 19.7273C52.9446 19.7273 51.5809 21.091 51.5809 22.7758V23.792H39.3868V22.7758C39.3868 21.091 38.0231 19.7273 36.3383 19.7273C34.6535 19.7273 33.2898 21.091 33.2898 22.7758V23.792H32.2736C26.1095 23.792 21.0957 28.8058 21.0957 34.9699V57.3257C21.0957 63.4897 26.1095 68.5035 32.2736 68.5035H58.6941C64.8582 68.5035 69.8719 63.4897 69.8719 57.3257V34.9699C69.8719 28.8058 64.8582 23.792 58.6941 23.792ZM58.6941 62.4065H32.2736C29.473 62.4065 27.1927 60.1262 27.1927 57.3257V38.0184H63.7749V57.3257C63.7749 60.1262 61.4946 62.4065 58.6941 62.4065Z",
    fill: "#00226F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3573 48.8553C54.3573 49.6255 53.8207 50.2738 53.207 50.6153L50.0284 52.3834L51.4388 56.2306C51.7112 56.9765 51.4652 57.8118 50.8311 58.2894C50.1828 58.7772 49.2886 58.7711 48.6464 58.2752L45.4841 55.8303L42.3217 58.2752C41.6795 58.7711 40.7853 58.7772 40.137 58.2894C39.5029 57.8118 39.257 56.9765 39.5293 56.2306L40.9397 52.3834L37.7611 50.6153C37.1474 50.2738 36.6108 49.6255 36.6108 48.8553C36.6108 48.2029 37.1779 47.4814 38.0965 47.4814H42.6632L43.8744 42.8416C44.0655 42.1058 44.726 41.5937 45.4841 41.5795C46.2421 41.5937 46.9026 42.1058 47.0937 42.8416L48.3049 47.4814H52.8716C53.7902 47.4814 54.3573 48.2008 54.3573 48.8553Z",
    fill: "#4A90E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.f664453d8b49500fd555a136b7077c84.svg";
export { ForwardRef as ReactComponent };